var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UserRecipientForm.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1030f20a\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UserRecipientForm.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue/src/components/forms/UserRecipientForm.vue
// module id = 210
// module chunks = 0